(ns practitest.frontend.users-view.utils
  (:require [practitest.frontend.common.i18n :refer [get-translation format-translation]]))

(def table-id "users-view-index")

(def selection-path [:users-view :users-view-index])

(def pat-states ["disabled" "enabled" "enabled_with_impersonation"])

(defn pat-state-label [pat-state]
  (case pat-state
    "disabled" (get-translation "generic.label.disabled" "Disabled")
    "enabled" (get-translation "generic.label.enabled" "Enabled")
    "enabled_with_impersonation" (get-translation "users-view.pat-state.enabled-with-impersonation" "Enabled with Impersonation")
    pat-state))

(defn pat-label->state [label]
  (or (some #(when (= label (pat-state-label %)) %) pat-states)
      label))

;; Groups belong to a project and their names repeat across projects, so the
;; groups filter offers group/project pairs rather than bare group names.
(defn group-filter-label [group-name project-name]
  (format-translation
    (get-translation "users-view.groups-filter.option" "%{group} - %{project}")
    :group group-name
    :project project-name))

(defn group-label->id [all-groups label]
  (some #(when (= label (group-filter-label (:name %) (:project_name %))) (:id %))
        all-groups))
